import { Component } from '@angular/core';

import { Register } from '../../shared';

import { ShareMapToolOptions } from './share-map-tool.interface';


@Register({
  name: 'shareMap',
  title: 'igo.shareMap.share',
  icon: 'share'
})
@Component({
  selector: 'igo-share-map-tool',
  template: require('./share-map-tool.component.html'),
  styles: [require('./share-map-tool.component.styl')]
})
export class ShareMapToolComponent {

  public options: ShareMapToolOptions = {};

  get hasCopyLinkButton(): boolean {
    return this.options.hasCopyLinkButton === undefined ?
      false : this.options.hasCopyLinkButton;
  }

  get hasShareMapButton(): boolean {
    return this.options.hasShareMapButton === undefined ?
      false : this.options.hasShareMapButton;
  }

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/share-map-tool/share-map-tool.component.ts